import store from '../store'

export default function guest (to, from, next) {
  if (store.getters['auth/isAuthenticated']) {
    return next({
      path: '/'
    })
  }

  return false
}
